var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIcModalClose = function SvgIcModalClose(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.725 3.4A.937.937 0 1 0 3.4 4.725l5.277 5.278L3.4 15.28a.937.937 0 1 0 1.326 1.326l5.277-5.277 5.277 5.277a.938.938 0 0 0 1.326-1.326l-5.277-5.277 5.277-5.278A.938.938 0 0 0 15.28 3.4l-5.277 5.277L4.725 3.4Z"
  })));
};
export default SvgIcModalClose;